export const getInfuraProjectId = (): string => {
  return process.env.REACT_APP_INFURA_PROJECT_ID as string;
};
